import { render, staticRenderFns } from "./AdvertisementPreview.vue?vue&type=template&id=acfba19c&"
import script from "./AdvertisementPreview.vue?vue&type=script&lang=ts&"
export * from "./AdvertisementPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports